import { useRef, useState } from 'react';

export function RadiusInput({ value, onCommit, className }: { value: number; onCommit: (v: number) => void; className: string }) {
  const [draft, setDraft] = useState<string | null>(null);
  const cancelled = useRef(false);
  const commit = () => {
    if (cancelled.current) { cancelled.current = false; return; }
    const v = draft === null ? value : Number(draft);
    if (Number.isFinite(v) && v >= 10 && v <= 50000) onCommit(v);
    setDraft(null);
  };
  return <input aria-label="Neighbour search radius in kilometres" type="number" min="10" max="50000" step="10" value={draft ?? String(value)}
    onChange={e => setDraft(e.target.value)} onBlur={commit}
    onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); cancelled.current = true; setDraft(null); e.currentTarget.blur(); } }} className={className} />;
}
